import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pushModal } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { AutogramSubscriptionOptions, DeepPartial } from 'types';
import useOnMount from './useOnMount';

export interface UseBlueskyAutomationAuthenticatorResults {
  authenticate: () => Promise<DeepPartial<AutogramSubscriptionOptions>>;
}

export default function useBlueskyAutomationAuthenticator(
  shouldAutoOpen?: boolean,
  appRedirectUrl?: string,
  onAuthenticated?: (result: DeepPartial<AutogramSubscriptionOptions>) => void,
): UseBlueskyAutomationAuthenticatorResults {
  const reduxDispatch = useDispatch<Dispatch>();

  const authenticate = useCallback(async (): Promise<
    DeepPartial<AutogramSubscriptionOptions>
  > => {
    const autopost = await reduxDispatch(
      pushModal({
        name: 'BlueskyAutoPost',
        params: {
          appRedirectUrl,
        },
      }),
    );

    if (autopost) {
      onAuthenticated?.({ autopost });

      return {
        autopost,
      };
    }

    return undefined;
  }, [appRedirectUrl, onAuthenticated, reduxDispatch]);

  useOnMount(
    useCallback(() => {
      if (shouldAutoOpen) {
        authenticate();
      }
    }, [authenticate, shouldAutoOpen]),
  );

  return {
    authenticate,
  };
}
